import { render, staticRenderFns } from "./CompanyAssetAddresses.vue?vue&type=template&id=69c2b716"
import script from "./CompanyAssetAddresses.vue?vue&type=script&lang=js"
export * from "./CompanyAssetAddresses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69c2b716')) {
      api.createRecord('69c2b716', component.options)
    } else {
      api.reload('69c2b716', component.options)
    }
    module.hot.accept("./CompanyAssetAddresses.vue?vue&type=template&id=69c2b716", function () {
      api.rerender('69c2b716', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/companysetting/assets/CompanyAssetAddresses.vue"
export default component.exports